/**
 * Helper functions for constructing URLs
 * Ensures correct URLs in both development and production
 */

/**
 * Get the base API URL for backend calls
 * In production, uses the current origin
 * In development, uses environment variable or localhost:3001
 */
export const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:3001';
};

/**
 * Get the socket URL for Socket.IO connections
 */
export const getSocketUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  return process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';
};

/**
 * Get the frontend base URL (where users access the app)
 * Always uses window.location.origin (the current page URL)
 */
export const getFrontendUrl = () => {
  return window.location.origin;
};

/**
 * Construct audience view URL for a session
 */
export const getAudienceUrl = (sessionId) => {
  return `${getFrontendUrl()}/view/${sessionId}`;
};

/**
 * Construct display view URL for a session
 */
export const getDisplayUrl = (sessionId) => {
  return `${getFrontendUrl()}/display/${sessionId}`;
};

/**
 * Construct manage URL for a session
 */
export const getManageUrl = (sessionId) => {
  return `${getFrontendUrl()}/manage/${sessionId}`;
};

export default {
  getBaseUrl,
  getSocketUrl,
  getAudienceUrl,
  getDisplayUrl,
  getManageUrl
};

